// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRenewalHealthPlanDto } from './IRenewalHealthPlanDto';
import {
    IRenewalHealthPlanDtoFromJSON,
    IRenewalHealthPlanDtoFromJSONTyped,
    IRenewalHealthPlanDtoToJSON,
    IRenewalHealthPlanDtoToJSONTyped,
} from './IRenewalHealthPlanDto';
import type { IRenewalPlanDto } from './IRenewalPlanDto';
import {
    IRenewalPlanDtoFromJSON,
    IRenewalPlanDtoFromJSONTyped,
    IRenewalPlanDtoToJSON,
    IRenewalPlanDtoToJSONTyped,
} from './IRenewalPlanDto';
import type { IRenewalPayrollCalendarDto } from './IRenewalPayrollCalendarDto';
import {
    IRenewalPayrollCalendarDtoFromJSON,
    IRenewalPayrollCalendarDtoFromJSONTyped,
    IRenewalPayrollCalendarDtoToJSON,
    IRenewalPayrollCalendarDtoToJSONTyped,
} from './IRenewalPayrollCalendarDto';
import type { IRenewalCopayDto } from './IRenewalCopayDto';
import {
    IRenewalCopayDtoFromJSON,
    IRenewalCopayDtoFromJSONTyped,
    IRenewalCopayDtoToJSON,
    IRenewalCopayDtoToJSONTyped,
} from './IRenewalCopayDto';
import type { IRenewalPlanYearDto } from './IRenewalPlanYearDto';
import {
    IRenewalPlanYearDtoFromJSON,
    IRenewalPlanYearDtoFromJSONTyped,
    IRenewalPlanYearDtoToJSON,
    IRenewalPlanYearDtoToJSONTyped,
} from './IRenewalPlanYearDto';

/**
 * 
 * @export
 * @interface IRenewalJson
 */
export interface IRenewalJson {
    /**
     * 
     * @type {IRenewalPlanYearDto}
     * @memberof IRenewalJson
     */
    new_plan_year?: IRenewalPlanYearDto;
    /**
     * 
     * @type {Array<IRenewalPlanDto>}
     * @memberof IRenewalJson
     */
    plans?: Array<IRenewalPlanDto>;
    /**
     * 
     * @type {Array<IRenewalCopayDto>}
     * @memberof IRenewalJson
     */
    copays?: Array<IRenewalCopayDto>;
    /**
     * 
     * @type {Array<IRenewalHealthPlanDto>}
     * @memberof IRenewalJson
     */
    health_plans?: Array<IRenewalHealthPlanDto>;
    /**
     * 
     * @type {Array<IRenewalPayrollCalendarDto>}
     * @memberof IRenewalJson
     */
    payroll_calendars?: Array<IRenewalPayrollCalendarDto>;
}

/**
 * Check if a given object implements the IRenewalJson interface.
 */
export function instanceOfIRenewalJson(value: object): value is IRenewalJson {
    return true;
}

export function IRenewalJsonFromJSON(json: any): IRenewalJson {
    return IRenewalJsonFromJSONTyped(json, false);
}

export function IRenewalJsonFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRenewalJson {
    if (json == null) {
        return json;
    }
    return {
        
        'new_plan_year': json['new_plan_year'] == null ? undefined : IRenewalPlanYearDtoFromJSON(json['new_plan_year']),
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(IRenewalPlanDtoFromJSON)),
        'copays': json['copays'] == null ? undefined : ((json['copays'] as Array<any>).map(IRenewalCopayDtoFromJSON)),
        'health_plans': json['health_plans'] == null ? undefined : ((json['health_plans'] as Array<any>).map(IRenewalHealthPlanDtoFromJSON)),
        'payroll_calendars': json['payroll_calendars'] == null ? undefined : ((json['payroll_calendars'] as Array<any>).map(IRenewalPayrollCalendarDtoFromJSON)),
    };
}

export function IRenewalJsonToJSON(json: any): IRenewalJson {
    return IRenewalJsonToJSONTyped(json, false);
}

export function IRenewalJsonToJSONTyped(value?: IRenewalJson | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'new_plan_year': IRenewalPlanYearDtoToJSON(value['new_plan_year']),
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(IRenewalPlanDtoToJSON)),
        'copays': value['copays'] == null ? undefined : ((value['copays'] as Array<any>).map(IRenewalCopayDtoToJSON)),
        'health_plans': value['health_plans'] == null ? undefined : ((value['health_plans'] as Array<any>).map(IRenewalHealthPlanDtoToJSON)),
        'payroll_calendars': value['payroll_calendars'] == null ? undefined : ((value['payroll_calendars'] as Array<any>).map(IRenewalPayrollCalendarDtoToJSON)),
    };
}

